import { Command } from '@ckeditor/ckeditor5-core';
import { first } from '@ckeditor/ckeditor5-utils';
export default class InsertStatInsightCommand extends Command {
    refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    execute(options) {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        const blocks = Array.from(selection.getSelectedBlocks());
        const value = !options || options.forceValue === undefined ? !this.value : options.forceValue;
        model.change((writer) => {
            if (!value) {
                this._removeStatInsight(writer, blocks.filter(findStatInsight));
            }
            else {
                const blocksToStatInsight = blocks.filter((block) => {
                    return findStatInsight(block) || checkCanBeStatInsighted(schema, block);
                });
                this._applyStatInsight(writer, blocksToStatInsight);
            }
        });
    }
    _getValue() {
        const selection = this.editor.model.document.selection;
        const firstBlock = first(selection.getSelectedBlocks());
        return !!(firstBlock && findStatInsight(firstBlock));
    }
    _checkEnabled() {
        if (this.value) {
            return true;
        }
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = first(selection.getSelectedBlocks());
        if (!firstBlock) {
            return false;
        }
        return checkCanBeStatInsighted(schema, firstBlock);
    }
    _removeStatInsight(writer, blocks) {
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            if (groupRange.start.isAtStart && groupRange.end.isAtEnd) {
                writer.unwrap(groupRange.start.parent);
                return;
            }
            if (groupRange.start.isAtStart) {
                const positionBefore = writer.createPositionBefore(groupRange.start.parent);
                writer.move(groupRange, positionBefore);
                return;
            }
            if (!groupRange.end.isAtEnd) {
                writer.split(groupRange.end);
            }
            const positionAfter = writer.createPositionAfter(groupRange.end.parent);
            writer.move(groupRange, positionAfter);
        });
    }
    _applyStatInsight(writer, blocks) {
        const insightsToMerge = [];
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            let statInsight = findStatInsight(groupRange.start);
            if (!statInsight) {
                statInsight = writer.createElement('statInsight');
                writer.wrap(groupRange, statInsight);
            }
            insightsToMerge.push(statInsight);
        });
        insightsToMerge.reverse().reduce((currentQuote, nextQuote) => {
            // TODO: make this ok
            // if (currentStatInsight.nextSibling == nextStatInsight) {
            //   writer.merge(writer.createPositionAfter(currentStatInsight))
            //   return currentStatInsight
            // }
            // return nextStatInsight
        });
    }
}
function findStatInsight(elementOrPosition) {
    if (elementOrPosition.parent == null)
        return null;
    return elementOrPosition.parent.name == 'statInsight' ? elementOrPosition.parent : null;
}
function getRangesOfBlockGroups(writer, blocks) {
    let startPosition = null;
    let i = 0;
    const ranges = [];
    while (i < blocks.length) {
        const block = blocks[i];
        const nextBlock = blocks[i + 1];
        if (!startPosition) {
            startPosition = writer.createPositionBefore(block);
        }
        if (!nextBlock || block.nextSibling != nextBlock) {
            ranges.push(writer.createRange(startPosition, writer.createPositionAfter(block)));
            startPosition = null;
        }
        i++;
    }
    return ranges;
}
function checkCanBeStatInsighted(schema, block) {
    const isStatInsightAllowed = schema.checkChild(block.parent, 'statInsight');
    const isBlockAllowedInStatInsight = schema.checkChild(['$root', 'statInsight'], block);
    return isStatInsightAllowed && isBlockAllowedInStatInsight;
}
